export const PARTNER_ITEM_SELECTOR = '.partner-list-item';
export const PARTNERS_SELECTOR = '[data-partner]';
export const PARTNER_SLIDER_TIMEOUT = 3000;
export const PARTNER_VISIBLE_ITEMS = 6;
